import { Screen } from '~/screens/users/[userId]';

export const UsersShow: React.FC = () => <Screen />;
